export const currencies = {
  USD: { symbol: "$", rate: 1 },
  EUR: { symbol: "€", rate: 0.92 },
  CNY: { symbol: "¥", rate: 7.25 },
  RUB: { symbol: "₽", rate: 89 },
  TJS: { symbol: "SM", rate: 10.9 },
  USDT: { symbol: "USDT", rate: 1 }
};

export type Currency = keyof typeof currencies;

export function formatMoney(amountUsd: number, currency: Currency = "USD") {
  const cfg = currencies[currency] ?? currencies.USD;
  const value = amountUsd * cfg.rate;
  return currency === "USDT" ? `${value.toFixed(2)} ${cfg.symbol}` : `${cfg.symbol}${value.toFixed(2)}`;
}
